import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class CsvImport {
  csvUrl: string = './csv_upload?id=';  // URL to web API

  constructor (private http: HttpClient) {}

  public readCsvData (fileName: any) {
    console.log('begin');

    let reader: FileReader = new FileReader();
    reader.readAsText(fileName.target.files[0]);

    reader.onload = (e) => {
      let unsureCSV = reader.result;
      if (typeof unsureCSV !== 'string') {return}
      let csv = unsureCSV as string;
      let allTextLines = csv.split(/\r|\n|\r/);
      let headers = allTextLines[0].split(',');
      let lines = [];

      for (let i = 0; i < allTextLines.length; i++) {
        // split content based on comma
        let data = allTextLines[i].split(',');
        if (data.length === headers.length) {
          let tarr = [];
          for (let j = 0; j < headers.length; j++) {
            tarr.push(data[j]);
          }

          // log each row to see output
          console.log(tarr);
          lines.push(tarr);
        }
      }
    };
  }
}
